import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  TextField,
  DateField,
  required,
} from 'react-admin';

export const BlockedEmailDomainList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="emailDomain" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const BlockedEmailDomainCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="emailDomain" validate={required()} />
    </SimpleForm>
  </Create>
);

export const BlockedEmailDomainEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled label="Id" source="id" />
      <TextInput source="emailDomain" validate={required()} />
    </SimpleForm>
  </Edit>
);
